import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, Home, Info, Phone } from 'lucide-react'

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()

  const navigation = [
    { name: 'Ana Sayfa', href: '/', icon: Home },
    { name: 'İlanlar', href: '/ilanlar', icon: Home },
    { name: 'Hakkımızda', href: '/hakkimizda', icon: Info },
    { name: 'İletişim', href: '/iletisim', icon: Phone },
  ]

  const isActive = (path) => location.pathname === path
  const isHomePage = location.pathname === '/'
  
  // Tamamen şeffaf header sayfaları (anasayfa hariç)
  const transparentPages = ['/ilanlar', '/hakkimizda', '/iletisim']
  const isTransparentPage = transparentPages.includes(location.pathname)
  
  // Hero section'lu sayfalar (beyaz metin)
  const heroPages = ['/', '/ilanlar', '/hakkimizda', '/iletisim']
  const isHeroPage = heroPages.includes(location.pathname)
  
  // Hero sayfalarda beyaz, diğer sayfalarda koyu renk
  const textColor = isHeroPage ? 'text-white' : 'text-gray-800'
  const subTextColor = isHeroPage ? 'text-white/80' : 'text-gray-600'
  const hoverColor = isHeroPage ? 'hover:text-primary-300' : 'hover:text-primary-600'
  const activeColor = isHeroPage ? 'text-primary-300 border-primary-300' : 'text-primary-600 border-primary-600'

  return (
    <header className={`absolute top-0 left-0 right-0 z-50 ${
      isTransparentPage ? '' : isHomePage ? 'backdrop-blur-sm' : 'backdrop-blur-sm bg-white/95'
    }`}>
      {/* Logo - Sabit sol üst köşe */}
      <Link 
        to="/" 
        className="hover:opacity-80 transition-opacity duration-200 absolute top-4 left-4 z-10"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <img 
          src="/foto/logo.png" 
          alt="Organize Gayrimankul Logo" 
          className="h-20 w-auto"
        />
      </Link>

      <div className="container-custom">
        <div className="flex justify-between items-center py-6">
          {/* Boş alan - Logo artık absolute pozisyonda */}
          <div className="opacity-0 pointer-events-none">
            <img 
              src="/foto/logo.png" 
              alt="Organize Gayrimankul Logo" 
              className="h-20 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => {
              const Icon = item.icon
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center space-x-2 px-1 py-2 text-sm font-light transition-colors duration-200 ${
                    isActive(item.href)
                      ? `${activeColor} border-b-2`
                      : `${textColor} ${hoverColor}`
                  }`}
                >
                  <Icon size={16} />
                  <span>{item.name}</span>
                </Link>
              )
            })}
          </nav>

          {/* Mobile menu button */}
          <button
            className={`md:hidden p-2 ${textColor} ${hoverColor} transition-colors duration-200`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className={`md:hidden py-4 border-t ${
            isTransparentPage ? 'border-white/20' : 
            isHomePage ? 'border-white/20 backdrop-blur-sm' : 
            'border-gray-200 bg-white/95 backdrop-blur-sm'
          }`}>
            <nav className="space-y-2">
              {navigation.map((item) => {
                const Icon = item.icon
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`flex items-center space-x-3 px-4 py-3 text-sm font-light transition-colors duration-200 ${
                      isActive(item.href)
                        ? `${activeColor} ${isHeroPage ? 'bg-white/20' : 'bg-gray-100'}`
                        : `${textColor} ${hoverColor} ${isHeroPage ? 'hover:bg-white/10' : 'hover:bg-gray-50'}`
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <Icon size={16} />
                    <span>{item.name}</span>
                  </Link>
                )
              })}
            </nav>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header 